// extracted by mini-css-extract-plugin
export var navigationWrapper = "Slider-module--navigationWrapper--3wNYi";
export var dots = "Slider-module--dots--6i326";
export var dot = "Slider-module--dot--36AF3";
export var arrow = "Slider-module--arrow--O0AZ7";
export var arrowLeft = "Slider-module--arrowLeft--gt8M-";
export var arrowRight = "Slider-module--arrowRight--1kRuY";
export var arrowDisabled = "Slider-module--arrowDisabled--3Et37";